<script lang="ts">
  import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
  import Fa from 'svelte-fa';
  import { Card,CardBody,CardHeader } from "sveltestrap";
  import { gamestate } from "../stores";
  import Skills from "./Skills.svelte";
</script>

{#each $gamestate.journalists as journalist}
  <div class="mb-3" class:opacity-75={journalist.currentProject}>
    <Card>
      <CardHeader>
        <Fa icon={faUserCircle}></Fa> {journalist.firstName} {journalist.lastName}
      </CardHeader>

      <CardBody>
        {#if Object.keys(journalist.skills).length === 0}
          <div class="text-secondary">
            No expertise yet. Journalists can write articles on their expert topics faster and with higher quality.
          </div>
        {:else}
          <Skills journalist={journalist} />
        {/if}
      </CardBody>
    </Card>
  </div>
{/each}